const ASSET_STATUS_UNREALIZED: string = 'unrealized';

export default ASSET_STATUS_UNREALIZED;
